<template>
    <div class="wui-container no_auth_code">
        <p>{{ $t("no_auth_code.header") }}</p>
        <ul>
            <li>{{ $t("no_auth_code.step1") }}</li>
            <li>{{ $t("no_auth_code.step2") }}</li>
            <li>{{ $t("no_auth_code.step3") }}<span class="email">hello@wellcee.com</span>{{ $t("no_auth_code.step4") }}</li>
        </ul>
        <div class="card">
            <div class="title">{{ $t("no_auth_code.card.title") }}</div>

            <div class="list">
                <div class="item">{{ $t("no_auth_code.card.item1") }}</div>
                <div class="item">{{ $t("no_auth_code.card.item2") }}</div>
                <div class="item">{{ $t("no_auth_code.card.item3") }}</div>
                <div class="item">{{ $t("no_auth_code.card.item4") }} {{ email }}</div>
                <div class="item">{{ $t("no_auth_code.card.item5") }}</div>
            </div>
        </div>
        <p>{{ $t("no_auth_code.footer") }}</p>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { useRoute } from "vue-router";

export default {
    data() {
        return {
            email: 'maxim@wellcee.com',
        };
    },
    mounted() {
        const route = useRoute();
        if (route.query.theme == 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark');
        }
        if (route.query.lang && ['zh', 'en', 'tw'].includes(route.query.lang)) {
            this.$i18n.locale = route.query.lang
        }
        document.title = this.$t('no_auth_code.title');
    },
    methods: {
        
    },
};
</script>

<style scoped>
.no_auth_code{
    box-sizing: border-box;
    min-height: 100vh;
    overflow: hidden;
    padding: 30px;
    background-color: var(--wlc-bg-white);
}
.no_auth_code p {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 19px;
    color: var(--wlc-text-color);
}
.no_auth_code .email{
    color: var(--wlc-primary-color);
}
.no_auth_code ul{
    margin: 20px 0;
}
.no_auth_code ul li {
    list-style-type: decimal;
    list-style-position: inside;
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    color: var(--wlc-text-color);
}
.no_auth_code .card{
    padding: 15px;
    border-radius: 10px;
    background: var(--wlc-bg-color);
}
.no_auth_code .card .title{
    font-size: 12px;
    font-weight: 600;
    line-height: 17px;
    margin-bottom: 20px;
    color: var(--wlc-text-gray-color);
}
.no_auth_code .card .list .item{
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
    margin-top: 6px;
    color: var(--wlc-text-gray-color);
}
</style>
